import Env from "../base/env";
import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    this.DOM.view.muted = true;
    this.DOM.view.setAttribute("webkit-playsinline", "webkit-playsinline");
    this.DOM.view.setAttribute("playsinline", "playsinline");
    this.DOM.view.setAttribute("src", this.DOM.view.getAttribute("data-src"));
    this.DOM.view.currentTime = 0.1;

    gsap.delayedCall(0.2, () => {
      this.detect();
      this.listener();
    });
  }

  detect() {
    if (this.DOM.view.classList.contains("video-all")) {
      this.DOM.view.play();
    } else {
      if (Env.mobileCSS == true) {
        if (this.DOM.view.classList.contains("video-mobile")) {
          this.DOM.view.play();
        }
      } else {
        if (this.DOM.view.classList.contains("video-desktop")) {
          this.DOM.view.play();
        }
      }
    }
  }

  listener() {
    this.stListener = ScrollTrigger.create({
      trigger: this.DOM.view,
      onEnter: () => {
        this.detect();
      },
      onEnterBack: () => {
        this.detect();
      },
      onLeave: () => {
        this.DOM.view.pause();
      },
      onLeaveBack: () => {
        this.DOM.view.pause();
      },
    });
  }

  unmount() {
    this.stListener.kill();
  }
}
